<script lang="ts">
	export let size = 0;
	let className = '';
	export { className as class };

	function applySize(size: number) {
		let props: any = {};
		if (size > 0) {
			props.style = `width: ${size}px`;
		} else {
			props.style = `width: 100%`;
		}
		return props;
	}
	$: props = applySize(size);
</script>

<table class={className} {...props}>
	<thead class="">
		<slot name="columns" />
	</thead>
	<tbody class="table-body">
		<slot name="rows" />
	</tbody>
</table>

<style>
</style>
